import React from 'react';
import { FaHome } from 'react-icons/fa';

function NotFoundPage() {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gray-100 text-center p-6">
      {/* Illustration */}
      <div className="max-w-md">
        <img
          src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
          alt="404 Illustration"
          className="w-full mb-6"
        />
      </div>

      {/* Message */}
      <h1 className="text-5xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-2">Page Not Found</h2>
      <p className="text-gray-600 mb-6">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>

      {/* Back to Dashboard Button */}
      <a
        href="/dashboard"
        className="flex items-center space-x-2 bg-pragyaBlue text-white px-6 py-3 rounded-lg shadow-md hover:bg-pragyaBlue/90 transition-transform transform hover:scale-105"
      >
        <FaHome className="text-lg" />
        <span className="text-lg font-medium">Back to Dashboard</span>
      </a>
    </div>
  );
}

export default NotFoundPage;
